;(function () {
  angular.module('contrast.score').directive('scoreBar', function () {
    return {
      restrict: 'E',
      controller: 'csScoreCtrl',
      controllerAs: 'csScoreCtrl',
      bindToController: {
        scoreBarTitle: '@',
        scoreBarSubtitle: '@',
        isDefaultScoring: '=',
        scoreType: '@',
        score: '=',
        defense: '=',
        hasDefense: '=',
        infoBold: '=',
        assessToggle: '&',
        assessment: '=',
        hasAssessment: '=',
        scoreBarLoading: '=',
        isAssessLanguageSupported: '='
      },
      scope: {},
      templateUrl: 'views/common/score_bar.html'
    }
  })
})()
